import type { paths } from '@luxuryescapes/contract-svc-merchandise'
import requestUtils from 'api/requestUtils'
import qs from 'qs'

type Response = paths['/api/merchandise/search/categories']['get']['responses']['200']['content']['application/json']

async function getMerchandiseCategoriesList(filters: App.MerchandiseCategoryFilters): Promise<Array<string>> {
  const query = qs.stringify({
    name: filters.name || undefined,
    brandIds: filters.brands?.length ? filters.brands : undefined,
    sortBy: filters.sortBy || undefined,
    limit: filters.limit || undefined,
    level: filters.level,
  }, { arrayFormat: 'comma' })

  return requestUtils.get<Response>(`/api/merchandise/search/categories?${query}`).then((response) => {
    return response.result.categoryIds
  })
}

export default getMerchandiseCategoriesList
